import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EmployeeDto } from '@coin/shared/core/util-models';
import { from, Observable, switchMap } from 'rxjs';

/**
 * Opens the emulation dialog and emits the selected employee (undefined when cancelled).
 * The dialog is imported on demand so it stays out of the apps' startup bundle; hence a function instead of a static openDialog.
 */
export function openSelectEmulatePersonDialog(
  dialog: MatDialog,
  config?: MatDialogConfig
): Observable<EmployeeDto | undefined> {
  return from(import('./select-emulate-person.component')).pipe(
    switchMap(module =>
      dialog.open<unknown, unknown, EmployeeDto>(module.SelectEmulatePersonComponent, config).afterClosed()
    )
  );
}
